import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";

type Tabs = {
  activeTab: string;
  onBlur?: (e: React.FocusEvent<HTMLButtonElement>) => void;
  setActiveTab: (value: string) => void;
  unmount?: boolean;
};

export const TabsContext = createContext<Tabs>(createDefaultContext());
